import { MutationTree } from 'vuex';
import { State } from './state';
import { ServiceViewMutationTypes } from './mutation-types';
import { PortfolioApiResponseResults } from './types';

export type Mutations<S = State> = {
  [ServiceViewMutationTypes.SET_PORTFOLIO_DATA](
    state: S,
    payload: {
      portfolioData: Array<PortfolioApiResponseResults>;
      portfolioDataCount: number;
    }
  ): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [ServiceViewMutationTypes.SET_PORTFOLIO_DATA](
    state: State,
    payload: {
      portfolioData: Array<PortfolioApiResponseResults>;
      portfolioDataCount: number;
    }
  ) {
    state.portfolio.portfolioData = payload.portfolioData;
    state.portfolio.portfolioDataCount = payload.portfolioDataCount;
  },
};
